import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {push} from 'react-router-redux';
import Radium from 'radium';
import * as defaultStyles from '../styles';
import {request} from '../containers/actions';
import {logout} from '../containers/actions';
import {activateMenuItem, deactivateMenu} from '../menu/actions';
import {PAGE_ADMIN} from '../containers/actions.js';
import Menu from '../menu/Menu.js';
import { Toolbar, ToolbarRow, ToolbarSection } from 'rmwc';
import { Button } from 'rmwc';

const theme = {
    primaryColor: 'rgb(50, 50, 255)',
    secondaryColor: '#f4f4f4',
};


const styleGenerator = (topbar, type, props) => {
    switch (type) {
    case 'Menu': {
        if ((props.level || 0) === 0) {
            return {
                margin: 0,
                paddingRight: 0,
                display: 'flex',
                borderRight: `1px solid ${theme.secondaryColor}`,
                flexFlow:'wrap'
            };
        }
        else if (props.level === 1) {
            const style = {
                transition: 'max-height 500ms linear, opacity 300ms',
                position: 'absolute',
                top: topbar.props.bottomRowHeight,
                backgroundColor: defaultStyles.thirdColor,
                borderLeft: '.0625em solid white',
                borderRight: '.0625em solid white',
                //borderBottom: '.0625em solid white',
                borderBottomLeftRadius: '.5rem',
                borderBottomRightRadius: '.5rem',
                left: '50%',
                transform: 'translateX(-50%)',
                listStyle: 'none',
                padding: '0',
                overflow: 'hidden',
                overflowY: 'auto'
            };
            if (props.active)
                return {
                    ...style,
                    maxHeight: '20rem',
                    zIndex: 100,
                };
            else
                return {
                    ...style,
                    opacity: '.8',
                    maxHeight: 0,
                };
        }
    }

    case 'MenuItem': {
        if (props.level == 1) {
            return {
                display: 'inline-block',
                float: 'right',
                backgroundColor: defaultStyles.primaryColor,
                height: `${topbar.props.bottomRowHeight}px`,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: '.5rem',
                paddingRight: '.5rem',
                marginTop: 0,
                marginBottom: 0,
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                display: 'flex',
                borderLeft: `1px solid ${theme.secondaryColor}`,
                flex: '1',
                width: '6em',
            };
        }
        else {
            return {
                paddingTop: '.1rem',
                paddingBottom: '.1rem',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                marginTop: '.2rem',
                marginBottom: '.2rem',
                position: 'relative',
                display: 'block',
                borderBottom: props.index === props.all.length - 1 ? undefined : '.0625em solid white',
                textAlign: 'center',
                minWidth: '5em',
            };
        }
    }

    case 'MenuItemText':
    case 'MenuText': {
        const style = {
            display: 'inline',
            transition: 'opacity .6s',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            color: theme.secondaryColor,
            ':hover': {
                color: props.level > 1 ? defaultStyles.secondaryColor : theme.secondaryColor,
            },
        };
        return style;
    }

    case 'MenuItemIcon':
    case 'MenuIcon': {
        const style = {
            display: 'inline',
            transition: 'padding .6s',
            width: '1rem',
            textAlign: 'center',
            color: Number(props.level) > 1 ? theme.secondaryColor : theme.primaryColor,
            marginLeft: '.2rem',
            cursor: 'pointer',
            width: '1rem',
        };
        return style;
    }

    default:
        throw(new Error(`No style for type ${type}`));
    }
};


// //@Radium //TODO check it later
export default class Topbar extends React.PureComponent {
    static propTypes = {
        topRowHeight: PropTypes.number.isRequired,
        topRowMinimumHeight: PropTypes.number.isRequired,
        bottomRowHeight: PropTypes.number.isRequired,
    }
    static contextTypes = {
        store: PropTypes.object,
        router: PropTypes.object,
        user: PropTypes.object,
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            topRowHeight: props.topRowHeight,
            left: 0,
            menu: false,
            combobar:false,
        };
    }

    componentWillMount() {
        this.calculateHeight.bind(this)();
    }

    componentDidMount() {
        const calculateHeight = this.calculateHeight.bind(this);
        const closeMenu = ({target}) => {
            if (
                this.refs.menu &&
                !this.refs.menu.contains(target)
            )
                this.closeMenu.bind(this)();
        };
        window.addEventListener('click', closeMenu);
        window.addEventListener('scroll', calculateHeight, {passive: true});
        this.cleanUp = () => {
            window.removeEventListener('click', closeMenu);
            window.removeEventListener('scroll', calculateHeight);
        };
    }

    componentWillUnmount() {
        this.cleanUp();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pageType !== this.props.pageType)
            this.calculateHeight.bind(this)();
    }

    closeMenu() {
        this.setState({menu: false});
    }

    calculateHeight() {
        let scroll = document.body.scrollTop;

        let newHeight = Math.max(
            this.props.topRowMinimumHeight,
            this.props.topRowHeight - scroll,
        );
        this.setState({
            topRowHeight: this.props.pageType === PAGE_ADMIN ? this.props.topRowMinimumHeight : newHeight,
        });
    }

    renderAuthenticatedBar() {
        return <span style={{color: theme.secondaryColor}}>
            <div ref='menu' style={{...styles.topRowButton, cursor: 'pointer', position: 'relative'}}
                onClick={event => {
                    this.setState({menu: !this.state.menu});
                    event.preventDefault();
                }}>
                <span style={{color: '#cacaca'}}>
                    {window.gettext('Greetings')}
                </span>&nbsp;
                {_.includes(this.context.user.type, 'student')
                    ? (this.context.user.firstname || '')
                    : (this.context.user.gender === 1
                        ? window.gettext('Mr.')
                        : this.context.user.gender === 2
                            ? window.gettext('Mrs.')
                            : ''
                    ) + (this.context.user.lastname || '')
                }
                &nbsp;&nbsp;&nbsp;&nbsp;
                <i style={{color: 'rgb(0, 200, 0)', fontSize: '1.1em'}} className='fa-caret-down'></i>
                &nbsp;
                {this.state.menu
                    ? <div
                        style={{
                            position: 'absolute',
                            top: '100%',
                            right: '0',
                            backgroundColor: 'white',
                            zIndex: '100',
                            width: '12em',
                            color: 'black',
                        }}>
                        <div
                            key='profile'
                            style={{
                                cursor: 'pointer',
                                padding: '.5em',
                                border: '.0625em solid #9a9a9a',
                                marginTop: '-.0625em',
                                ':hover': {
                                    backgroundColor: '#cacaca',
                                },
                            }}
                            onClick={() => this.context.store.dispatch(push('/profile/'))}>
                            {window.gettext('User Account')}
                        </div>
                        <div
                            key='logout'
                            style={{
                                cursor: 'pointer',
                                padding: '.5em',
                                border: '.0625em solid #9a9a9a',
                                marginTop: '-.0625em',
                                ':hover': {
                                    backgroundColor: '#cacaca',
                                },
                            }}
                            onClick={() => this.context.store.dispatch(logout())}>
                            <i className='fa-sign-out'></i>&nbsp;{window.gettext('logout')}
                        </div>
                    </div>
                    : null
                }
            </div>
            {/* <div
                style={{...styles.topRowButton, cursor: 'pointer', position: 'relative'}}
                onClick={event => {
                    event.preventDefault();
                    if (this.props.shoppingItems && this.props.shoppingItems.size)
                        this.context.store.dispatch([
                            push('/store/purchase/summary/'),
                            request({
                                path: '/order/register_incomplete_order/',
                                body: {items: this.props.shoppingItems.toArray()},
                                metohd: 'POST',
                            }),
                        ]);
                    else
                        this.context.store.dispatch(push('/store/orders/'));
                }}>
                <i className='fa-shopping-cart' style={{fontSize: '1.6em'}}></i>
                {this.props.shoppingItems && (this.props.shoppingItems.size ? 1 : 0) + this.props.pendingOrders > 0
                    ? <div
                        style={{
                            backgroundColor: '#fb002f',
                            color: 'white',
                            padding: '.1em .4em',
                            height: '1.2em',
                            textAlign: 'center',
                            fontSize: '.85em',
                            fontWeight: '700',
                            position: 'absolute',
                            left: '1.5em',
                            top: '-.5em',
                            lineHeight: '1.4em',
                            boxShadow: 'rgba(0, 0, 0, 0.22) .0625em .0625 .0625em',
                            borderRadius: '.25em',
                            border: `1px solid ${theme.primaryColor}`,
                        }}>
                        {((this.props.shoppingItems.size ? 1 : 0) + this.props.pendingOrders).persian()}
                    </div>
                    : null
                }
            </div>
            <div
                style={{...styles.topRowButton, cursor: 'pointer', position: 'relative'}}
                onClick={event => {
                    event.preventDefault();
                    this.context.store.dispatch(push('/messages/'));
                }}>
                <i className='fa-envelope' style={{fontSize: '1.5em'}}></i>
                {this.props.unreadMessages > 0
                    ? <div
                        style={{
                            backgroundColor: '#fb002f',
                            color: 'white',
                            padding: '.1em .4em',
                            height: '1.2em',
                            textAlign: 'center',
                            fontSize: '.85em',
                            fontWeight: '700',
                            position: 'absolute',
                            left: '1.5em',
                            top: '-.5em',
                            lineHeight: '1.4em',
                            boxShadow: 'rgba(0, 0, 0, 0.22) .0625em .0625 .0625em',
                            borderRadius: '.25em',
                            border: `1px solid ${theme.primaryColor}`,
                        }}>
                        {this.props.unreadMessages.persian()}
                    </div>
                    : null
                }
            </div>
            <div
                style={{...styles.topRowButton, cursor: 'pointer', position: 'relative'}}
                onClick={event => {
                    event.preventDefault();
                }}>
                <i className='fa-bell' style={{fontSize: '1.5em'}}></i>
                {this.props.unreadMessages > 1000
                    ? <div
                        style={{
                            backgroundColor: '#fb002f',
                            color: 'white',
                            padding: '.1em .4em',
                            height: '1.2em',
                            textAlign: 'center',
                            fontSize: '.85em',
                            fontWeight: '700',
                            position: 'absolute',
                            left: '1.5em',
                            top: '-.5em',
                            lineHeight: '1.4em',
                            boxShadow: 'rgba(0, 0, 0, 0.22) .0625em .0625 .0625em',
                            borderRadius: '.25em',
                            border: `1px solid ${theme.primaryColor}`,
                        }}>
                        {this.props.unreadMessages.persian()}
                    </div>
                    : null
                }
            </div> */}
        </span>;
    }

    renderUnAuthenticatedBar() {
        return <span>
            <div
                style={{...styles.topRowButton, cursor: 'pointer'}}
                onClick={event => {
                    // console.log("this.context.store.getState(): ",this.context.store.getState().get('routing').get('locationBeforeTransitions'));
                    event.preventDefault();
                    this.context.store.dispatch(push({
                        ...this.context.store.getState().get('routing').get('locationBeforeTransitions')/*.toJS()*/,
                        query: {dialog: 'login'},
                    }));
                }}>
                <i className='fa-sign-in'></i>&nbsp;
                {window.gettext('login')}
            </div>
            {/* <div
                style={{...styles.topRowButton, cursor: 'pointer'}}
                onClick={event => {
                    event.preventDefault();
                    this.context.store.dispatch(push({
                        ...this.context.store.getState().get('routing').get('locationBeforeTransitions').toJS(),
                        query: {dialog: 'registration'},
                    }));
                }}>
                {window.gettext('register')}
            </div> */}
        </span>;
    }

    showCombobar()
    {
        return window.innerWidth-this.staticMenuWidth()<50;
    }

    staticMenuWidth()
    {
        return this.context.store.getState().getIn(['application', 'token', 'accessToken'])?370:230
    }

    render() {
        return <span>
            <div
                style={{
                    height: (this.props.pageType === PAGE_ADMIN
                        ? this.props.topRowMinimumHeight
                        : this.props.topRowHeight
                    ) + this.props.bottomRowHeight*2,
                }}>
            </div>
            <div
                style={{
                    ...styles.container,
                    height: this.state.topRowHeight + this.props.bottomRowHeight,
                }}>
                <div
                    style={{
                        ...styles.topRow,
                        height: this.state.topRowHeight,
                        backgroundPositionY: this.state.topRowHeight - this.props.topRowHeight,
                    }}>
                    <div
                        style={{
                            ...styles.topRowBar,
                            height: this.props.topRowBarHeight,
                        }}>
                        <Toolbar
                            style={{
                                width: `calc(100% - ${Math.floor((this.props.topRowHeight + this.props.bottomRowHeight) * 1.2) + 10}px)`,
                                backgroundColor: theme.primaryColor,
                            }}>
                            <ToolbarRow>
                                <ToolbarSection onClick={()=>this.setState({combobar:!this.state.combobar})} shrinkToFit alignStart style={{
                                        cursor: 'pointer',
                                        marginRight:5,
                                        display:this.showCombobar()?null:'none'
                                    }}>
                                    <i className='fa-bars' style={{fontSize: '1.5em'}}></i>
                                    {
                                        this.state.combobar?
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    right: '0',
                                                    backgroundColor: 'white',
                                                    zIndex: '100',
                                                    width: '12em',
                                                    color: 'black',
                                                }}>
                                                {_.map(this.props.applicationsMenu.items, (item, index) => <div
                                                        style={{
                                                            cursor: 'pointer',
                                                            padding: '.5em',
                                                            border: '.0625em solid #9a9a9a',
                                                            marginTop: '-.0625em',
                                                            ':hover': {
                                                                backgroundColor: '#cacaca',
                                                            },
                                                        }}
                                                        key={index}
                                                    onClick={() => this.context.store.dispatch(push(item.uri))}>
                                                    {item.title}
                                                    </div>)
                                                }
                                            </div>
                                            :null
                                    
                                    }
                                </ToolbarSection>
                                <ToolbarSection shrinkToFit alignStart>
                                    {this.context.store.getState().getIn(['application', 'token', 'accessToken'])
                                        ? this.renderAuthenticatedBar.bind(this)()
                                        : this.renderUnAuthenticatedBar.bind(this)()
                                    }
                                </ToolbarSection>
                                {/* <ToolbarSection shrinkToFit alignStart style={{
                                        alignItems: 'center', marginRight: '.7em',
                                        width:Math.max(0,window.innerWidth-this.staticMenuWidth()),
                                        overflowX:'auto',
                                        display:this.showCombobar()?'none':null
                                    }}>
                                    {_.map(this.props.applicationsMenu.items, (item, index) => <Button
                                        style={{
                                            color: (
                                                this.context.store.getState().getIn(['routing', 'locationBeforeTransitions', 'pathname']) ===
                                                item.uri ||
                                                this.props.application === (item.application || {}).name
                                            ) ? '#00e871' : theme.secondaryColor,
                                            backgroundColor: undefined,
                                        }}
                                        key={index}
                                        onClick={() => this.context.store.dispatch(push(item.uri))}>
                                        {item.title}
                                    </Button>)}
                                </ToolbarSection> */}
                            </ToolbarRow>
                        </Toolbar>
                    </div>
                    <div
                        style={{
                            ...defaultStyles.rowLogo,
                            position: 'relative',
                            marginTop: -this.props.topRowBarHeight,
                        }}>
                        <a
                            style={styles.logo}
                            href='/'
                            onClick={event => {
                                event.preventDefault();
                                this.context.store.dispatch(push('/'));
                            }}>
                            {/* <svg
                                style={{marginTop: '5px'}}
                                height={this.state.topRowHeight - 10}
                                viewBox='40.4 188.5 502 413.3'>
                                <g id='text'>
                                    <path fill='white' d='
M463.1,591.4c-0.2-2.3-1.4-3.7-3.4-4.3c-0.9-0.2-2-0.3-2.9-0.3l-0.2,0c-5.1-0.1-10.4-0.2-15.5-0.3
c-6.8-0.1-1.6,0-8.4-0.3c-8.8-0.4-16.2-0.8-23.5-2.1c-1-0.1-1.9-0.3-2.7-0.5c-3.2-0.8-5-1.8-5.9-3.4c-1.1-1.8-0.9-4.6,0.5-9.3
c0-0.2,0.1-0.3,0.1-0.4c0-0.1,0.1-0.2,0.1-0.3c1.8-5.1,3.8-10,8.5-13c1.2-0.8,2-1,2.7-0.9c0.6,0.1,1.1,0.6,1.7,1.4
c2.6,3.8,5.3,7.6,7.3,10.5c0.5,0.7,1,1.3,1.6,2c0.3,0.4,0.7,0.8,1.1,1.3l1.5-0.3c1.2-3.7,2.1-8-0.4-12c-2.2-3.5-4.3-6.6-6.5-9.4
c-2.1-2.6-4.1-4.2-6.2-4.7c-3.2-0.8-6.2,0.8-9.1,4.7c-3.3,4.4-6.1,9.7-8,15.3c-2.5,7.2-2.8,14.5-0.9,21.8c-0.9-0.2-1.8-0.3-2.7-0.5
c-2.9-0.5-5.6-1-8.3-1.6l-0.4-0.1c-5-1.2-8.1-4.4-9-9.6c-0.3-1.9-0.7-3.8-1-5.8c-1-5.2-2-10.7-2.6-16c-1.1-10.2-2-20.7-2.9-30.7
c-0.6-6.7-1.2-13.5-1.8-20.2c-1.6-17.3-3.4-35.7-5.9-59.6c-1.4-13.6-2.6-24.7-3.8-34.9c-0.2-1.5-0.8-2.8-1.4-4.1
c-0.3-0.6-0.5-1.1-0.7-1.7l-1-0.6l-1.3,0.2l-0.6,0.4c-2.2,3.7-4.5,7.4-3.9,12.5c1.1,8.9,2.1,17.8,3.1,26.6
c0.4,3.9,0.9,7.7,1.3,11.5c0.4,3.3,0.8,6.6,1.2,9.9c0.9,7.6,1.8,15.4,2.6,23.1c0.7,7.2,1.3,14.7,1.9,21.8c0.4,4.5,0.8,9,1.1,13.5
c0.4,4.6,0.9,9.1,1.4,13.8l0.3,3.3c-0.6-0.8-1.3-1.6-1.9-2.4c-2.6-3.2-5-6.3-7.8-9.1c-14.6-14.4-31.2-27-47.2-39.1
c-2.3-1.7-4.6-3.5-6.9-5.2l-5.4-4.1c-9.9-7.5-20.1-15.2-29.8-23.3c-7.2-6.1-14.6-12.8-18-22.5c-0.3-1-1.2-1.6-2.1-2.2
c-0.3-0.2-0.7-0.5-0.9-0.7l-1.3,0.1c-0.2,0.3-0.5,0.6-0.8,1c-0.7,0.8-1.4,1.7-1.7,2.7c-1.5,6.3,1.5,11.5,4.5,15.7
c8.1,11.2,18.7,19.9,28.8,27.7c5.7,4.4,11.4,8.8,17.1,13.2c13.1,10.1,26.6,20.6,39.8,31c11.8,9.3,20.2,18,26.6,27.6
c5.5,8.2,7,17.1,4.7,26.6c-0.6,2.5-2.3,5.1-4,6.2c-6.3,4.2-12.1,7.6-17.9,10.3c-2.4,1.2-5.1,1.7-7.9,2.4c-1.6,0.4-3.3,0.7-4.9,1.2
c-0.9,0.3-1.5,1-2.1,1.6c-0.2,0.3-0.4,0.5-0.7,0.7l0.1,1.4c0.3,0.2,0.5,0.3,0.7,0.5c0.6,0.4,1.3,0.9,2.1,1.2l0.2,0.1
c0.7,0.2,1.5,0.2,2.3,0.3c0.5,0,1,0.1,1.6,0.2c9.1,1.5,17.5-0.6,25.8-6.4c6-4.2,10.6-9.3,14.3-16l0.9,3.3c1.9,6.8,6,11.1,11.7,12.6
l0.5,0.1c7,1.6,14.5,3,22.1,3.2c8.3,0.2,16.8,0,25-0.3c5-0.2,10.2-0.3,15.3-0.3c0.5,0,0.9,0,1.2,0c-2.4-0.1,1.9,0,0,0
c0.2,0,0.5,0,0.9,0c3.7,0.1,7.5,0.1,11.3,0.2c2.6,0,4.2-0.5,5.2-1.5C462.9,595.2,463.3,593.7,463.1,591.4z'/>
                                    <path fill='white' d='
M156.8,549.8c3.8,0.1,7.6,0,11.3-0.1l1.9-0.1c2,0,4.4-1.7,5.8-3.2c0.9-0.9,1.8-2.2,1.8-3.5
c-0.1-2.8-2.2-3.4-2.9-3.5c-0.4-0.1-0.9-0.2-1.3-0.2c-0.4-0.1-0.8-0.1-1.1-0.2L172,539c-7.2-2.2-14.4-4.4-21.6-6.5
c-7.6-2.3-15.3-4.6-22.8-7c-2.9-0.9-5.7-2-8.5-3c-0.8-0.3-1.5-0.6-2.2-0.9c0,0,6.4-5.4,10.9-9.1c4.1-3.4,9.2-11.8,9.2-11.8
c2.9,7.9,8.3,13,15.7,14.8c0.6,0.2,1.3,0.3,1.9,0.4c8.5,1.4,18.3,2.8,28.1,2.6c7.6-0.2,15.3-1.2,22.8-2.1c4.1-0.5,8.3-1,12.4-1.4
c8.5-0.8,16.9-1.3,24.8-1.8c6.9-0.4,13.3-0.7,19.2-0.8c4.4-0.1,8.9-0.1,13.2-0.1c3.3,0,6.5,0,9.8,0c4.8-0.1,9.2-3,10.6-6.9
c0.3-0.9,0.6-2,0.1-2.9c-0.3-0.5-0.8-0.9-1.6-1.1c-0.4-0.1-0.9-0.1-1.4-0.1c-2.5,0-5.1,0-7.5-0.1c-2.5,0-5.2-0.1-7.8,0
c-14.9,0.2-30.8-1.3-50.3-4.9c-8.4-1.5-16.7-3.1-25-4.7c-9-1.7-18.2-3.5-27.4-5.2c-3-0.6-5.9-0.4-8,0.5c-1.6,0.7-2.7,2.1-3.8,3.5
c-0.4,0.6-0.9,1.1-1.3,1.6l-3.1,4.1c-0.5,0.5,0.2,1.5,1,1c3.8-2.7,8.3-1.3,8.3-1.3c8.3,1.8,16,4.1,24.1,5.7
c2.9,0.6,5.8,1.2,8.7,1.8l9.8,2c-1.3,0.2-2.5,0.4-3.8,0.6c-0.9,0.1-1.9,0.2-2.8,0.4c-14,2.3-28.4,1.9-44-1.1
c-0.4-0.1-0.9-0.2-1.3-0.3c-7.9-2-13.2-7.3-14.2-14.4c-1.4-9.7-6.2-78.1-7.6-90.8c-1.2-10.5-2.3-21.3-3.4-32
c-0.8-8.3-1.5-16.7-2.1-24.9c-0.5-6.9-1.1-14-1.8-20.9c-1.3-14.1-2.9-28.6-4.4-41c-0.2-1.6-0.8-3.4-2-5.4c-0.2-0.4-0.7-0.7-1.4-0.8
c-1-0.3-2.4-0.4-2.7,0.4c-0.4,0.8-0.8,1.6-1.2,2.5c-1.3,2.4-2.6,4.9-2.6,7.5c0.1,4.7,0.7,9.5,1.3,14.1c0.3,2.3,0.6,4.6,0.9,6.9
c0.5,4.4,0.9,8.7,1.3,13.1c0.4,4.3,0.9,8.7,1.3,13.1c0.6,5,1.1,10,1.7,15c0.8,7.2,1.6,14.6,2.4,22c0.3,2.8,0.4,5.7,0.5,8.5
c0.1,2.9,0.3,5.8,0.6,8.7c0.6,6.4,1.3,12.8,2.1,19.1c1,9.4,2.1,19.2,3,28.8c0.7,7.2,1,14.6,1.3,21.8c0.2,4.3,0.2,8.6,0.6,12.9
c2.2,20.2-3.3,29.9-7.9,34.2c-3.7,3.5-7.9,6.9-12.3,10.1c-2.8,2-5.6,3.4-8.1,4c-3.5,0.9-5.8,2.3-6.4,6.8c-0.5,3.9,2.5,5,4.8,5.7
l0.2,0.1c6.5,2.2,12.9,4.3,19.3,6.4l9.5,3.1c0.2,0.1,0.5,0.2,0.7,0.3c-2.8,0.3-5.6,0.5-8.3,0.8c-5.2,0.5-10.4,1-15.6,1.5
c-9.8,1-21.1,1.9-32-0.8c-1.9-0.5-3.7-1-5.5-1.7c-8.6-3.1-16.8-7.5-19.8-18.1c-1.4-5.1-1.6-10.4-0.5-16.2c2.9-15,10-27.6,21.3-37.6
c0.8-0.8,1.5-1.7,2.3-2.6c0.3-0.5,0.7-1,1.1-1.5l-0.5-1.4l-0.5-0.1c-4.3-0.7-5-0.6-10.1,4.2c-10.9,10.4-18.3,23.5-21.9,39.1
c-2.7,11.4-2,20.3,2.3,28c2.1,3.8,5.6,9.1,10.3,12c5.8,3.6,12.7,5.7,18.7,7.5c0.7,0.2,1.4,0.4,2.1,0.6c10.5,2.6,21.2,1.2,31.6-0.1
l2.2-0.3C123.2,551.1,139.9,549.3,156.8,549.8z'/>
                                    <path fill='white' d='
M316.4,560.2c-0.2-0.4-0.5-0.8-0.7-1.1l-1.3-0.4c-0.4,0.3-0.8,0.5-1.2,0.7c-0.9,0.6-1.9,1.1-2.7,1.9
c-2.2,2.3-4.4,4.6-6.4,6.9c-0.6,0.7-1.2,1.4-1.8,2c-5.4-5.3-8.3-16-6.2-23.4c0.7-2.5,1.9-4.8,3.2-7.3c0.7-1.4,1.5-2.9,2.2-4.4
c0.4-0.8,0.3-1.8,0.1-2.7c0-0.3-0.1-0.7-0.1-1l-1.2-0.8c-0.3,0.1-0.6,0.1-0.9,0.2c-0.8,0.2-1.7,0.4-2.3,1.1
c-9.7,12.3-12.2,24.6-7.6,37.8c1.2,3.4,1.1,6.3-0.2,8.5c-1.2,2.1-3.6,3.5-6.8,4c-6.3,1.1-11.9,1.9-17,2.5l-1.6,0.2
c-12,1.5-24.5,3-36.8,2.2c-2.3-0.2-4.2-0.4-6-0.9c-7.3-1.8-11.1-6.3-13.2-15.4c-0.2-0.9-0.4-1.9-0.6-2.8c-0.9-4.2-1.9-8.6-3.4-12.8
c-1.4-4.1-3.7-6.6-6.6-7.3c-2.9-0.7-6.2,0.4-9.5,3.2c-7.5,6.4-13.1,14.2-16.7,23.3c-1.9,4.9-4.1,9.9-8.8,13
c-1.9,1.3-3.9,1.8-5.6,1.4c-2.1-0.5-3.6-2.4-4.2-5.2c-0.7-3.6-1.2-7.3-1.7-10.9c-0.3-2-0.5-4.1-0.8-6.1c-0.2-0.9-0.4-1.8-0.6-2.7
c-0.1-0.3-0.2-0.7-0.3-1.1l-1.3-0.5c-1.4,0.8-2,1.6-2.2,2.6c-2.1,10.3-0.3,20.5,1.6,29.3c0.2,1.1,1.1,2,1.9,2.8
c1.8,1.8,4,3.1,6.4,3.6c4.9,1.2,9.7-0.4,12.7-4.3c3.1-4,5.7-8.7,7.5-13.5c3.4-8.7,8.2-15.7,14.8-21.3c1.7-1.5,3-2.1,4-1.8
c0.9,0.2,1.8,1.4,2.4,3.5c0.9,2.9,1.6,5.9,2.3,8.8c0.5,2.3,1.1,4.8,1.8,7.1c1.7,5.9,4,11.8,9.8,15.6c2.4,1.5,5,2.7,7.9,3.4
c3.6,0.9,7.6,1.2,12.4,0.8c16.4-1.2,33.1-3.1,49.2-5l2.4-0.3c3.9-0.5,7.4-2.8,10-6.8c1-1.5,1.9-3,2.8-4.5l0.5-0.8
c0.9,0.7,1.8,1.4,2.7,2.2c2.6,2.1,5.3,4.3,8.2,6.2c1.5,1,2.8,1.6,3.9,1.9c3.7,0.9,5.5-2.1,6.9-5.4c0.7-1.6,1-3,1-4.2
c-0.1-5.2-0.3-12.1-0.8-19C317.7,562.1,317,561.1,316.4,560.2z M310.5,579c-1.7-1.1-3-1.9-4.6-3c1.4-1.7,2.6-3.1,3.8-4.5
c0.3,0.1,0.5,0.2,0.8,0.3C310.5,574,310.5,576.1,310.5,579z'/>
                                </g>
                                <g id='kadr'>
                                    <polygon
                                        fill='#F26522'
                                        points='542.4,428.5 471.9,358.2 472,258.8 372.4,258.9 302,188.5 231.6,258.9 137.8,258.8 147.6,271.6 
                                        236.9,271.7 302,206.7 367,271.7 459.1,271.6 459,363.5 524.2,428.5 459,493.4 459.1,574.8 471.9,584.9 471.9,498.8'
                                    />
                                    <polygon
                                        fill='#F26522'
                                        points='513,427.2 451.5,365.8 451.5,279 364.5,279 303.1,217.6 241.6,279 159.7,279 168.3,290.2 246.3,290.3 
                                        303.1,233.5 359.9,290.3 440.3,290.2 440.2,370.5 497.1,427.2 440.2,483.9 440.3,555 451.5,563.8 451.5,488.5'
                                    />
                                </g>
                            </svg> */}
                        </a>
                    </div>
                </div>
                <div
                    style={{
                        ...styles.bottomRow,
                        minHeight: this.props.bottomRowHeight,
                        top: this.state.topRowHeight,
                    }}>
                    <div
                        style={{margin: '0 auto',width:'100%'}}>
                        <Menu
                            {...this.props.menu}
                            active
                            style={styleGenerator.bind(undefined, this)}
                            events={{
                                onMouseMove: (event, path) => {
                                    event.stopPropagation();
                                    if (!_.isEqual(this.props.menu.activePath, path))
                                        this.context.store.dispatch(activateMenuItem(path, this.props.menu.elementId));
                                },
                                onMouseLeave: (event, path) => {
                                    if (path.length === 0)
                                        this.context.store.dispatch(deactivateMenu(this.props.menu.elementId));
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
        </span>;
    }
}


const styles = {};
styles.container = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 500,
    backgroundColor: 'white',
};
styles.logo = {
    transition: 'height .8s, left .8s',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 1,
};
styles.topRow = {
    boxSizing: 'border-box',
    transition: 'height .8s, background-position-y .8s',
    position: 'relative',
    backgroundColor: theme.primaryColor,
    color: theme.secondaryColor,
};
styles.topRowBar = {
    ...defaultStyles.rowMenu,
};
styles.topRowButton = {
    float: 'right',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: '.5rem',
    paddingRight: '.5rem',
    marginTop: 0,
    marginBottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    display: 'flex',
};
styles.bottomRow = {
    width: '100%',
    borderBottom: `1px solid ${theme.secondaryColor}`,
    transition: 'top .8s',
    position: 'absolute',
    backgroundColor: defaultStyles.primaryColor,
};
